export default {
	Yes: 'Да',
	No: 'Нет',
	OK: 'ОК',
	Cancel: 'Отменить',
	Prev: 'Назад',
	Next: 'Вперед',
	Start: 'Начать',
	Finish: 'Завершить',
	Reset: 'Очистить',
	Undo: 'Отменить',
	Add: 'Добавить',
	Save: 'Сохранить',
	Create: 'Создать',
	Update: 'Обновить',
	Delete: 'Удалить',
	Dismiss: 'Скрыть',
	Retry: 'Повторить',
	Loading: 'Загрузка…',
	Processing: 'Обработка…',
	Error: {
		ReactError: {
			Title: 'Что-то определённо пошло не так…',
			Description: 'Свяжитесь с командой разработчиков, чтобы получить помощь'
		},
		NotFound: {
			Title: 'Ууупс… Такой страницы у нас нет!',
			Description: 'Страницы, которую вы ищете, не существует. Мы расстроены этим фактом не меньше вашего.',
		}
	}
};
